import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';

import { useDictionary } from 'bdvp-common/src/hooks/config';

const StatLine = styled.div`
    align-items: flex-end;
    display: flex;
    font-size: 13px;
    font-weight: 600;
    justify-content: space-between;
    line-height: 1;
    margin-top: 5px;
    position: relative;
    width: 100%;

    ${media.mdmin`
        font-size: 15px;
    `}
`;

const Value = styled.strong`
    font-size: 15px;
    font-weight: 700;

    ${media.mdmin`
        font-size: 18px;
    `}
`;

const CardStat = ({
    mediaPlayback,
    searchSortSelectedOption,
}) => {

    const dictionary = useDictionary();

    if(!mediaPlayback.playInfo || !searchSortSelectedOption?.resultsDisplay) {

        return null;

    }

    const {
        dataProperty,
        dictionaryKey,
        defaultLabel,
    } = searchSortSelectedOption.resultsDisplay;

    return (
        <StatLine>
            {dictionary[dictionaryKey] || defaultLabel}: <Value>{mediaPlayback.playInfo[dataProperty] || '-'}</Value>
        </StatLine>
    );

};

CardStat.propTypes = {
    mediaPlayback: PropTypes.object,
    searchSortSelectedOption: PropTypes.object,
};

CardStat.defaultProps = {
    mediaPlayback: {},
    searchSortSelectedOption: {},
};

export default CardStat;
